<template>
  <div v-if="accountStore.operationalManager">
    <div class="content-container">
      <div v-if="accountStore.operationalManager.mainPicture">
        <SingleAvatarStudent
          :picture="accountStore.operationalManager.mainPicture.format.big"
          size="184px"
          rounded="false"
        />
      </div>
      <div class="info-container">
        <div class="info">
          <div class="name">{{ accountStore.operationalManager.firstName }}
            {{ accountStore.operationalManager.lastName }}
            <span>Votre contact opérationnel</span>
          </div>
          <p>
            Bonjour {{ accountStore.firstName }},
          </p>
          <p>
            Je suis {{ accountStore.operationalManager.firstName }}, votre contact opérationnel chez {{ $brand.label }}.
            Je suis en charge du déploiement de vos projets et du suivi de vos besoins.
          </p>
          <p>
            N'hésitez pas à me contacter par téléphone ou par mail si vous avez une urgence, je
            vous répondrai au plus vite !
          </p>
        </div>
      </div>
    </div>
    <div class="sub-info">
      <ul>
        <li v-if="accountStore.operationalManager.email">
          <i class="fa fa-paper-plane" aria-hidden="true"/>
          <div class="text">
            {{ accountStore.operationalManager.email }}
          </div>
          <span class="span">Mon email</span>
        </li>
        <li v-if="accountStore.operationalManager.phone">
          <i class="fa fa-phone" aria-hidden="true"/>
          <div class="text">
            {{ $tel(accountStore.operationalManager.phone) }}
          </div>
          <span class="span">Mon numéro de téléphone</span>
        </li>
        <li class="num">
          <i class="fa fa-exclamation-circle" aria-hidden="true"/>
          <div class="text">
            01 86 95 02 15
          </div>
          <span class="span">Numéro de garde pour les urgences en soirées et Week-ends</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SingleAvatarStudent from '@/components/MyStudents/SingleAvatarStudent';
import { mapStores } from 'pinia';
import { useAccountStore } from '@/stores/account';

export default {
  components: {
    SingleAvatarStudent,
  },
  computed: {
    ...mapStores(useAccountStore),
  },
};
</script>
